module.exports = __webpack_public_path__ + "static/title-2-8e4b7b78171126303dfee9f7a974c226.png";